export const editSelected = () => ({
    type: 'EDIT_SELECTED'
})

export default {
    editSelected
}